<template>
  <lwf-table
    v-bind="config"
    :columns="columns"
    :data="data"
    :loading="loading"
    :pagination.sync="config.pagination"
    :selected.sync="selection"
    row-key="id"
    selection="multiple"
    v-on="$listeners"
    @request="onRequest"
  >
    <template #body-cell-createdAt="props">
      <lwf-td-multiline
        :actions="actions"
        :props="props"
      />
    </template>
    <template #body-cell-status="props">
      <q-td :props="props">
        <badge-status-contract :status="props.value" />
      </q-td>
    </template>
    <template #body-cell-signatures="props">
      <q-td>
        <div
          v-for="(val, i) in props.value"
          :key="i"
        >
          <q-badge
            v-if="val.type === 'badge'"
            v-bind="val"
          />
          <span v-else>{{ val.label }}</span>
        </div>
      </q-td>
    </template>
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        v-bind="props"
        :name="k"
      />
    </template>
  </lwf-table>
</template>

<script>
import tableMixin from 'components/Table/tableMixin'
import uiEventRefreshMixin from '@/mixins/uiEventRefreshMixin'
import LwfTable from 'components/core/LwfTable/LwfTable'
import LwfTdMultiline from 'components/core/LwfTable/LwfTdMultiline'
import { createNamespacedHelpers } from 'vuex'
import { MODAL_EVENT_UPDATE_CONTRACT } from '@/consts/app'
import { loadingHandler } from '@/utils/ui'
import { downloadFile } from '@/utils'
import { modalContract } from '@/utils/ui/modal'
import {
  CONTRACT_STATUS_ARCHIVED,
  CONTRACT_STATUS_SIGNED,
  DATA_AGENCY_CONTRACT_INDEXED_COLUMNS
} from '@/consts/data/contract'
import BadgeStatusContract from 'components/Badge/BadgeStatusContract'
import { contractDialogDelete, contractDialogSendForSignature, contractDialogSign } from '@/utils/data/contract'
import propsReadonly from '@/mixins/propsReadonly'

const storeUser = createNamespacedHelpers('user')
export default {
  name: 'TableAgencyContract',
  components: {
    BadgeStatusContract,
    LwfTdMultiline,
    LwfTable
  },
  mixins: [propsReadonly, tableMixin, uiEventRefreshMixin],
  DATA_KEY: 'data',
  EVENT_NAME: MODAL_EVENT_UPDATE_CONTRACT,
  INDEXED_COLUMNS: DATA_AGENCY_CONTRACT_INDEXED_COLUMNS,
  props: {
    type: {
      type: String,
      default: undefined
    },
    editData: {
      type: Object,
      default: _.stubObject
    },
    fetchFn: {
      type: Function,
      required: true
    },
    fetchFilters: {
      type: Object,
      default: _.stubObject
    },
    rightEdit: {
      type: Object,
      required: true
    },
    rightDelete: {
      type: Object,
      required: true
    },
    rightSign: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...storeUser.mapGetters({
      isGranted: 'isGranted',
      agency: 'company'
    }),
    actions: function () {
      return [
        {
          label: 'Télécharger',
          cb: (contract) => this.downloadContract(contract),
          showIf: true
        },
        {
          label: 'Modifier',
          cb: (contract) =>
            modalContract(
              this.type,
              {
                ...contract,
                ...this.editData
              }
            ),
          if: ({ status }) => [CONTRACT_STATUS_SIGNED, CONTRACT_STATUS_ARCHIVED].indexOf(status) === -1,
          showIf: !this.readonly && this.isGranted(this.rightEdit)
        },
        {
          label: 'Supprimer',
          cb: (contract) => contractDialogDelete(this.type, contract),
          if: ({ status }) => status !== CONTRACT_STATUS_ARCHIVED,
          showIf: !this.readonly && this.isGranted(this.rightDelete)
        },
        {
          label: 'Signer',
          cb: (contract) => contractDialogSign(this.type, contract),
          if: ({
            status,
            signatures = []
          }) => status !== CONTRACT_STATUS_ARCHIVED && signatures.length === 0,
          showIf: this.isGranted(this.rightSign)
        },
        {
          label: 'Envoyer pour signature',
          cb: (contract) => contractDialogSendForSignature(this.type, contract),
          if: ({
            status,
            signatures = []
          }) => status !== CONTRACT_STATUS_ARCHIVED && signatures.length > 0,
          showIf: this.isGranted(this.rightSign)
        }
      ].filter((a) => a.showIf)
    },
    _fetchOptions () {
      const {
        filters,
        ...fetchOptions
      } = this.fetchOptions
      return {
        ...fetchOptions,
        filters: {
          ...filters,
          ...this.fetchFilters
        }
      }
    }
  },
  methods: {
    _fetchData () {
      return this.fetchFn(this._fetchOptions)
    },
    downloadContract (contract) {
      loadingHandler(async () => {
        await downloadFile(contract.file.name, contract.file.url)
      })
    }
  }
}
</script>
